import styled from "styled-components";

const StyledImage = styled.div`
  overflow: hidden;
  width: ${({ width }) => width || "30px"};
  margin: 0;
  height: ${({ height }) => height || "30px"};
  display: flex;
  align-items: center;
  justify-content: center;

  img {
    width: 100%;
    height: 100%;
    object-fit: fill;
  }
`;
export default StyledImage;
